/* eslint-disable */
import cn from 'classnames';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import RulerPicker from 'src/onboarding/components/ui/ruler-picker/RulerPicker';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';

function Page() {
  const height = useStore((state) => state.height);
  const setHeight = useStore((state) => state.setHeight);
  const { onNext, onPrev, currentIndex } = useNav();

  const Next = () => {
    if (height.type === 'cm') {
      if (height.cm) {
        return (
          <div className={'next-wrapper'}>
            <Button
              title={t('onboarding.height.continue')}
              onClick={() => {
                Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                  page: 'height',
                  answer: height.cm,
                });
                onNext();
              }}
            />
          </div>
        );
      }
    } else if (height.type === 'ft') {
      if (height.ft) {
        return (
          <div className={'next-wrapper'}>
            <Button
              title={t('onboarding.height.continue')}
              onClick={() => {
                Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
                  page: 'height',
                  answer: height.ft,
                });
                onNext();
              }}
            />
          </div>
        );
      }
    }
  };

  const formatFeetInchesString = (value: number): string => {
    const feet = Math.floor(value);
    let inches = Math.round((value - feet) * 12);
    if (inches === 12) {
      return `${feet + 1}.0`;
    }
    return `${feet}.${inches}`;
  };
  const parseFeetInchesString = (str: string): number => {
    if (!str) return 0;
    const [feet, inches] = str.split('.').map(Number);
    return feet + inches / 12;
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.height.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {height.type === 'cm'
            ? t('onboarding.height.cmSubTitle')
            : t('onboarding.height.ftSubTitle')}
        </Text>
      </div>

      <div className={'controls controls_new'}>
        <div className={'tabs'}>
          <span
            className={cn({ active: height.type === 'cm' })}
            onClick={() => {
              setHeight({ ...height, type: 'cm' });
            }}
          >
            {t('onboarding.height.cm')}
          </span>
          <span
            className={cn({ active: height.type === 'ft' })}
            onClick={() => {
              setHeight({ ...height, type: 'ft' });
            }}
          >
            {t('onboarding.height.ft')}
          </span>
        </div>

        {height.type === 'cm' && (
          <RulerPicker
            min={90}
            max={243}
            step={1}
            onChange={(newValue) => setHeight({ type: 'cm', cm: String(newValue) })}
            unit='sm'
            initialValue={Number(height.cm)}
            stepWidth={15}
            divisions={5}
          />
        )}

        {height.type === 'ft' && (
          <RulerPicker
            unit='ft'
            min={3}
            max={8}
            step={1 / 12}
            stepWidth={5}
            onChange={(newValue) => {
              setHeight({ type: 'ft', ft: formatFeetInchesString(newValue) });
            }}
            initialValue={parseFeetInchesString(height.ft) || 5.7}
            divisions={12}
          />
        )}
      </div>
      <Next />
    </div>
  );
}

export default Page;
